export const campaigns = [
  {
    id: 1,
    title: 'Cilt Bakımı',
    desc: 'Derin nemlendirme ve cilt yenileme tedavisi. Uzman estetisyenler eşliğinde kişiselleştirilmiş bakım protokolü.',
    oldPrice: '₺1.200',
    newPrice: '₺749',
    badge: 'En Çok Tercih',
    badgeColor: '#00d9ff',
    image: 'https://readdy.ai/api/search-image?query=luxury%20facial%20skin%20care%20treatment%20in%20premium%20beauty%20salon%2C%20elegant%20dark%20moody%20atmosphere%2C%20golden%20light%20accents%2C%20professional%20skincare%20products%20on%20dark%20marble%20surface%2C%20ultra%20premium%20aesthetic%2C%20high%20end%20beauty%20photography%20with%20deep%20navy%20and%20gold%20tones&width=600&height=400&seq=camp001&orientation=landscape',
    tag: 'Cilt Bakımı',
  },
  {
    id: 2,
    title: 'Lazer Epilasyon',
    desc: 'Kalıcı tüy azaltma için en gelişmiş lazer teknolojisi. Ağrısız ve hızlı sonuç garantisi.',
    oldPrice: '₺2.500',
    newPrice: '₺1.490',
    badge: 'Fırsat',
    badgeColor: '#d4af37',
    image: 'https://readdy.ai/api/search-image?query=premium%20laser%20hair%20removal%20beauty%20treatment%20equipment%20in%20luxury%20clinic%2C%20dark%20elegant%20interior%20with%20soft%20blue%20and%20gold%20lighting%2C%20modern%20medical%20aesthetic%20device%2C%20high%20end%20beauty%20salon%20atmosphere%2C%20professional%20photography%20dark%20background&width=600&height=400&seq=camp002&orientation=landscape',
    tag: 'Lazer',
  },
  {
    id: 3,
    title: 'Dudak Renklendirme',
    desc: 'Kalıcı makyaj tekniğiyle doğal ve dolgun görünüm. Uzman pigmentasyon uygulaması.',
    oldPrice: '₺1.800',
    newPrice: '₺1.100',
    badge: 'Yeni',
    badgeColor: '#00d9ff',
    image: 'https://readdy.ai/api/search-image?query=luxury%20lip%20coloring%20permanent%20makeup%20beauty%20treatment%2C%20elegant%20dark%20studio%20with%20golden%20warm%20light%2C%20premium%20cosmetic%20pigments%20and%20tools%20on%20dark%20surface%2C%20high%20end%20beauty%20salon%20aesthetic%2C%20professional%20photography%20with%20deep%20dark%20background%20and%20gold%20accents&width=600&height=400&seq=camp003&orientation=landscape',
    tag: 'Kalıcı Makyaj',
  },
  {
    id: 4,
    title: 'G5 Sıkılaşma',
    desc: 'Selülit giderme ve vücut sıkılaştırma için G5 masaj teknolojisi. Görünür sonuçlar.',
    oldPrice: '₺3.200',
    newPrice: '₺1.950',
    badge: 'Popüler',
    badgeColor: '#d4af37',
    image: 'https://readdy.ai/api/search-image?query=premium%20G5%20body%20massage%20slimming%20treatment%20in%20luxury%20beauty%20spa%2C%20dark%20elegant%20room%20with%20soft%20golden%20ambient%20lighting%2C%20professional%20body%20contouring%20equipment%2C%20high%20end%20wellness%20center%20atmosphere%2C%20dark%20moody%20photography%20with%20warm%20gold%20tones&width=600&height=400&seq=camp004&orientation=landscape',
    tag: 'Vücut Bakımı',
  },
  {
    id: 5,
    title: 'VIP Paket',
    desc: 'Tüm premium hizmetlerin dahil olduğu özel VIP deneyim paketi. Kişisel danışman, öncelikli randevu ve özel hediye seti.',
    oldPrice: '₺8.500',
    newPrice: '₺4.990',
    badge: 'VIP',
    badgeColor: '#d4af37',
    image: 'https://readdy.ai/api/search-image?query=ultra%20luxury%20VIP%20beauty%20spa%20package%20experience%2C%20opulent%20dark%20interior%20with%20gold%20and%20champagne%20accents%2C%20premium%20beauty%20products%20arrangement%2C%20exclusive%20high%20end%20wellness%20atmosphere%2C%20dark%20background%20with%20warm%20golden%20glow%20and%20neon%20blue%20reflections%2C%20luxury%20photography&width=900&height=400&seq=camp005&orientation=landscape',
    tag: 'VIP',
    wide: true,
  },
];
